import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';

@Component({
  standalone: false,
  selector: 'ssc-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent implements AfterViewInit, OnDestroy {
  @Input() public titleKey: string;
  @Input() public startIndex = 0;

  public slideSelectionStates: boolean[] = [];
  public carousel: EmblaCarouselType;

  @ViewChild('viewportRef') private viewportRef: ElementRef;
  @ViewChild('containerRef') private containerRef: ElementRef;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    const container = this.containerRef.nativeElement;

    const firstRow = container.firstElementChild;
    if (!firstRow) return;

    const columnSlides = Array.from(firstRow.children) as HTMLElement[];
    if (columnSlides.length === 0) return;

    this.carousel = EmblaCarousel(this.viewportRef.nativeElement, {
      container: container,
      slides: columnSlides,
      startIndex: this.startIndex,
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
    });

    this.carousel.on('select', () => this.updateDots());
    this.carousel.on('reInit', () => this.setupDots());

    this.setupDots();
  }

  private setupDots(): void {
    const snapCount = this.carousel.scrollSnapList().length;
    this.slideSelectionStates = Array(snapCount).fill(false);
    this.updateDots();
  }

  private updateDots(): void {
    const current = this.carousel.selectedScrollSnap();
    this.slideSelectionStates = this.slideSelectionStates.map((_, i) => i === current);
    this.cdr.markForCheck();
  }

  public onDotClick(index: number): void {
    this.carousel.scrollTo(index);
  }

  public ngOnDestroy(): void {
    this.carousel?.destroy();
  }
}
